import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function GoogleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <g fillRule="evenodd">
        <path fill="#4285F4" d="M19.012 9.92c0-.687-.062-1.349-.176-1.984H9.7v3.753h5.22c-.224 1.212-.908 2.24-1.935 2.927v2.434h3.135c1.834-1.689 2.892-4.175 2.892-7.13z"/>
        <path fill="#34A853" d="M9.7 19.4c2.619 0 4.815-.869 6.42-2.35l-3.135-2.434c-.869.582-1.98.926-3.285.926-2.526 0-4.665-1.706-5.428-3.999h-3.24v2.513C2.628 17.226 5.908 19.4 9.7 19.4z"/>
        <path fill="#FBBC05" d="M4.272 11.543c-.194-.582-.304-1.204-.304-1.843 0-.64.11-1.261.304-1.843V5.344h-3.24A9.6941 9.6941 0 000 9.7c0 1.565.375 3.047 1.032 4.356l3.24-2.513z"/>
        <path fill="#EA4335" d="M9.7 3.858c1.424 0 2.703.49 3.708 1.45l2.782-2.782C14.51.961 12.315 0 9.7 0 5.908 0 2.628 2.174 1.032 5.344l3.24 2.513C5.035 5.564 7.174 3.858 9.7 3.858z"/>
      </g>
    </SvgIcon>
  )
}
export default GoogleIcon
